import type { ReactElement } from 'react'

import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { TitleLayout } from '@/components/enlayout'
import { Head } from '@/components/enlayouts/Head'
import { Layout } from '@/components/enlayouts/Ir'
import { AHeading } from '@/components/enlayouts/Ir/Heading'
import { Paragraph } from '@/components/enlayouts/Ir/Paragraph'

export const AntisocialPage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        enTitleText="Policy Against Antisocial Forces"
        subTitleText=""
      />
      <Spacer h={{ sp: 70, pc: 120 }} />
      <section>
        <AHeading>
         The fundamental approach to excluding antisocial forces and the current status of our efforts in this regard
        </AHeading>
        <Paragraph>
          The company operates under the policy of not engaging with any antisocial forces that may adversely affect societal order or the sound activities of the corporation. In line with this commitment, we disseminate and enforce the &apos;TRIAL Code of Conduct&apos; and the &apos;Measures Against Antisocial Forces&apos; regulations among the directors and employees of our corporate group. We are actively working to eliminate ties with antisocial forces and promote corporate ethics throughout the entire corporate group.
        </Paragraph>
        <Spacer h={{ sp: 20, pc: 30 }} />
        <Paragraph>
          Internally, we have established a framework where the Group Legal Manager is the overall responsible party for handling issues related to troubles involving civil intervention violence. Additionally, we instruct and implement the inclusion of clauses related to the exclusion of business partners and antisocial forces in contracts across various departments. To counter pressures from antisocial forces, we have also built collaborative relationships with external specialized organizations such as police stations and the Corporate Defense Measures Council.
        </Paragraph>
      </section>
    </Layout>
  )
}

AntisocialPage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'Home', path: '/en/' },
    { name: 'Investor Relations', path: '/en/ir/' },
    { name: 'Corporate Governance', path: '/en/ir/governance/' },
    { name: 'Policy Against Antisocial Forces', path: '' },
  ]

  return (
    <>
      <Head
        title="Policy Against Antisocial Forces"
        description="The fundamental approach to eliminate antisocial forces and the current status of our efforts this regard."
        ogp={{ url: 'en/ir/governance/antisocial/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle=""
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}
